import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/funding/_funding/transfer/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/registration/account/$accountId/funding', params });
  },
  preload: false,
});
